module.exports = __webpack_public_path__ + "img/article-image-1.72172544.jpeg";